export default [
  {
    path: "/bilgi-bankasi",
    name: "bilgi-bankasi",
    component: () => import("./BelgeListesi.vue"),
    meta: {
      pageTitle: "Bilgi Bankası",
      breadcrumb: [
        {
          title: "Bilgi Bankası",
          active: true,
        },
      ],
      yetki: { k: [1140002] },
    },
  },
  {
    path: "/bilgi-bankasi/galeri",
    name: "bilgi-bankasi-galeri",
    component: () => import("./Galeri.vue"),
    meta: {
      pageTitle: "Bilgi Bankası Galeri",
      breadcrumb: [
        {
          title: "Bilgi Bankası",
          to: { name: "bilgi-bankasi" },
        },
        {
          title: "Galeri",
          active: true,
        },
      ],
      yetki: { k: [1140202] }, // Using the yetki code from user's updated migration
    },
  },
  {
    path: "/bilgi-bankasi/kategoriler",
    name: "bilgi-bankasi-kategoriler",
    component: () => import("./KategoriYonetimi.vue"),
    meta: {
      pageTitle: "Kategori Yönetimi",
      breadcrumb: [
        {
          title: "Bilgi Bankası",
          to: { name: "bilgi-bankasi" },
        },
        {
          title: "Kategoriler",
          active: true,
        },
      ],
      yetki: { k: [1140102] },
    },
  },
  {
    path: "/bilgi-bankasi/olustur",
    name: "bilgi-bankasi-olustur",
    component: () => import("./BelgeForm.vue"),
    meta: {
      pageTitle: "Yeni Belge",
      breadcrumb: [
        {
          title: "Bilgi Bankası",
          to: { name: "bilgi-bankasi" },
        },
        {
          title: "Yeni Belge",
          active: true,
        },
      ],
      yetki: { k: [1140003] },
    },
  },
  {
    path: "/bilgi-bankasi/duzenle/:id",
    name: "bilgi-bankasi-duzenle",
    component: () => import("./BelgeForm.vue"),
    meta: {
      pageTitle: "Belge Düzenle",
      breadcrumb: [
        {
          title: "Bilgi Bankası",
          to: { name: "bilgi-bankasi" },
        },
        {
          title: "Düzenle",
          active: true,
        },
      ],
      yetki: { k: [1140004] },
    },
  },
]
